import styled from 'styled-components';

import { black } from '../../modules/colors';
import { fonts, spacing } from '../../modules/metrics';
import Card from '../card/Card';

export const CertificationsCard = styled(Card)`
  display: flex;
  align-items: baseline;
  margin-bottom: ${spacing.lg}px;
  padding: ${spacing.sm}px ${spacing.md}px;
`;

export const CertificationsTitle = styled.div`
  color: ${black};
  font-size: ${fonts.sm}px;
  margin-right: ${spacing.sm}px;
`;

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  > span {
    margin: ${spacing.sm}px ${spacing.sm}px ${spacing.sm}px 0;
  }
`;
